import { Themed } from "@components/atoms/Themed"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export const meta: ViewMeta = {
  templateName: "Work Page",
}

export default defineView("template-work", (props) => {
  return (
    <Themed page theme={props.page?.pageTheme} footer footerTheme={props.page?.footerTheme} className="w-full">
      <ContentBlocks blocks={props.page?.contentBlocks} />
    </Themed>
  )
})
